import { render, staticRenderFns } from "./ActionsComponent.vue?vue&type=template&id=63a0eea0"
import script from "./ActionsComponent.vue?vue&type=script&lang=js"
export * from "./ActionsComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/jquispe/itcm-inca-platform-app/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('63a0eea0')) {
      api.createRecord('63a0eea0', component.options)
    } else {
      api.reload('63a0eea0', component.options)
    }
    module.hot.accept("./ActionsComponent.vue?vue&type=template&id=63a0eea0", function () {
      api.rerender('63a0eea0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/ActionsComponent.vue"
export default component.exports